import { getflushQrcode, getBarcode } from 'services';
import { Toast } from 'antd-mobile';

let timer = null;

function* test(put) {
  yield put({
    type: 'use/queryflushQrcode',
    payload: {
      ...payload,
      refresh: true,
    },
  });
}

export default {
  namespace: 'use',
  state: {
    qrcodeMsg: {},
  },
  effects: {
    *queryflushQrcode({ payload, traceId, callback }, { call, put }) {
      // 判断是否刷新二维码 如果是定时刷新的二维码，则删除字段，不是清空定时器
      const response = yield call(getflushQrcode, payload, traceId);
      const { state, data, note } = response.data;
      if (state === '11') {
        if (!data.risk) {
          yield put({
            type: 'setData',
            payload: {
              qrcodeMsg: data,
            },
          });
        }
        callback && callback(data);
      }
      if (state === '02') {
        Toast.fail(note, 0);
      }
    },
    // 写开一个是为了预防刷新时候页面闪一下
    *refreshQrcode({ payload, traceId, callback }, { call, put }) {
      // 判断是否刷新二维码 如果是定时刷新的二维码，则删除字段，不是清空定时器
      const response = yield call(getflushQrcode, payload, traceId);
      const { state, data, note } = response.data;
      if (state === '11') {
        yield put({
          type: 'setData',
          payload: {
            qrcodeMsg: data,
          },
        });
        callback && callback(data);
      } else {
        callback && callback(false);
      }
      if (state === '02') {
        Toast.fail(note, 0);
      }
    },
    *getBarcode({ payload, callback }, { call, put }) {
      const response = yield call(getBarcode, payload);
      const { state, data, note } = response.data;
      if (state === '11') {
        // yield put({
        //   type: 'setData',
        //   payload: {
        //     qrcodeMsg: data,
        //   },
        // });
        callback && callback(data);
      }
      if (state === '02') {
        Toast.fail(note, 0);
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
